import { types } from './actions';

const initialState = {
  ticketId: null,
  jobId: null,
  jobView: true,
  deferredJobView: false,
  errorMessage: '',
  sorted: {
    columnName: 'approvedDate',
    order: 'desc',
  },
};


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.SELECT_TICKET_ID: {
      const { ticketId } = action;
      return {
        ...state,
        ticketId,
      };
    }
    case types.SELECT_JOB_ID: {
      const { jobId } = action;
      return {
        ...state,
        ticketId: null,
        jobId,
      };
    }
    case types.VIEW_JOBS: {
      return {
        ...state,
        jobView: true,
        deferredJobView: false,
      };
    }
    case types.VIEW_DEFERRED_JOBS: {
      return {
        ...state,
        jobView: false,
        deferredJobView: true,
      };
    }
    case types.SET_ERROR_MESSAGE: {
      const { errorMessage } = action;
      return {
        ...state,
        errorMessage,
      };
    }
    case types.CLEAR_ERROR_MESSAGE: {
      return {
        ...state,
        errorMessage: '',
      };
    }
    case types.SET_SORTED: {
      const { sorted } = action;
      return {
        ...state,
        sorted,
      };
    }
    default:
      return state;
  }
};


export default reducer;
